export default {"src":"/_next/static/media/logo-mobile.e44c58e7.svg","height":34,"width":80,"blurWidth":0,"blurHeight":0};